import Button from "./ui/Button";
import { elapsed, fecha_actual, fecha_completa } from "../hooks/elapsed";
import { useState } from "react";
import { Spinner } from "./Spinner";

export interface TramitesProps {
  data: any;
}

export const TablaCobranzaPolizaComponent = ({ data }: TramitesProps) => {
  return (
    <div className="w-full">
      <h1 className="mb-5 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
        Cobranza
      </h1>
      <div className="block w-full overflow-x-auto">
        <table className="w-full border-collapse items-center bg-transparent">
          <thead>
            <tr className="">
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Póliza
              </th>
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Serie
              </th>
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Vigencia Inicial
              </th>
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Fecha Envio
              </th>
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Fecha Pago Cliente
              </th>
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Monto
              </th>
              <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="dark:divide-gray-199 divide-y divide-gray-200">
            {data &&
              data.map((d: any) => {
                return (
                  <tr
                    key={d.ReciboID}
                    className="border-b-secondary-ultra-light"
                  >
                    <th className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs ">
                      <span className="flex flex-col">
                        <span>{d.Poliza_Promass}</span>
                      </span>
                    </th>
                    <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 text-xs">
                      <span className="flex flex-col">
                        <span>{d.Serie}</span>
                      </span>
                    </td>
                    <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                      <span className="flex flex-col">
                        <span>
                          {fecha_completa(d.Vig_Recibo_Ini)} al{" "}
                          {fecha_completa(d.Vig_Recibo_Fin)}
                        </span>
                      </span>
                    </td>
                    <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                      <span className="flex flex-col">
                        <span>
                          {d.Fecha_Pago
                            ? fecha_completa(d.Fecha_Pago)
                            : "No cobrado aún"}
                        </span>
                      </span>
                    </td>
                    <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                      <span className="flex flex-col">
                        {d.Fecha_Envio_Cobro
                          ? fecha_completa(d.Fecha_Envio_Cobro)
                          : "No cobrado aún"}
                      </span>
                    </td>
                    <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                      <span className="flex flex-col">
                        <span>{Number(d.Prima_Recibo).toFixed(2)}</span>
                      </span>
                    </td>
                    <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
                      <span className="flex flex-col">
                        {d.Id_Respuesta === 0 && (
                          <span className="rounded-xl bg-green-600 py-1 text-center text-white">
                            Cobrado
                          </span>
                        )}
                        {d.Id_Respuesta !== 0 && (
                          <span className="rounded-xl bg-red-600 py-1 text-center text-white">
                            No Cobrado
                          </span>
                        )}
                      </span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
